(function () {
  if (window.__ELMEVIA_GIFT_SYNC_LOADED__) return;
  window.__ELMEVIA_GIFT_SYNC_LOADED__ = true;

  var GIFT_VARIANT_ID = 57253472534906;
  var ELIGIBLE_VARIANT_IDS = [57250717991290, 57233877795194, 57250717172090, 57253970542970, 57254589596026, 57254343082362, 57253971755386, 57257843818874];
  var syncing = false;

  function changeGiftQuantity(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error('gift quantity update failed');
      window.location.reload();
    });
  }

  function syncGift() {
    if (syncing) return;
    syncing = true;

    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasEligible = items.some(function (item) {
          return ELIGIBLE_VARIANT_IDS.indexOf(item.variant_id) !== -1;
        });
        var giftLine = items.find(function (item) {
          return item.variant_id === GIFT_VARIANT_ID;
        });

        if (hasEligible && !giftLine) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
          }).then(function (res) {
            if (!res.ok) throw new Error('gift add failed');
            window.location.reload();
          });
        }

        if (hasEligible && giftLine && giftLine.quantity !== 1) {
          return changeGiftQuantity(giftLine.key, 1);
        }

        if (!hasEligible && giftLine) {
          return changeGiftQuantity(giftLine.key, 0);
        }
      })
      .catch(function (err) {
        console.error('ELMEVIA gift sync error', err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event && event.promise && typeof event.promise.then === 'function') {
      event.promise.then(syncGift).catch(syncGift);
    } else {
      syncGift();
    }
  });

  document.addEventListener('shopify:cart:view', syncGift);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGift, { once: true });
  } else {
    syncGift();
  }
})();
